<template>
  <long-list
    :api-method="getActivityList"
  >
    <template #default="{list}">
      <van-cell
        v-for="item in list"
        :key="item.agreementId"
        class="cell-card"
        :class="{'list-item__has-refund': inUnpaidList(item.agreementId)}"
        @click="onClickDetail(item.agreementId, item.agreementType)"
      >
        <div
          v-if="item.existTerminateLetter"
        >
          <van-icon
            name="warning"
            color="#FFD000"
          />解约退款通知
        </div>
        <div>活动编号：{{ item.agreementId }}</div>
        <div>活动类型：{{ getActivityDesc( item.agreementType) }}</div>
        <div>活动生效时间：{{ item.startTime | timeFilter }}</div>
        <text-arrow
          text="查看详情"
        />
        <van-tag
          type="primary"
          :color="activityIsInProgress(item.agreementStatus)?'#07c160':'gray'"
          class="tag"
        >
          {{ getActivityStatusDesc(item.agreementStatus) }}
        </van-tag>
        <van-tag
          v-if="inUnpaidList(item.agreementId)"
          type="warning"
          class="refund-tag"
        >
          需退款
        </van-tag>
      </van-cell>
    </template>
  </long-list>
</template>

<script>
import { mapState } from 'vuex';
import ActivityApi from '@/api/activity';
import LongList from '@/components/LongList';
import TextArrow from '@/components/TextArrow';
import STATUS from '@/constants/status';
import { getActivityDesc, getActivityStatusDesc, activityIsInProgress } from '@/constants/activity';
import { formatTimestamp } from '@/util/filter';

export default {
  name: 'ActivityIndex',
  components: {
    LongList,
    TextArrow,
  },
  filters: {
    timeFilter(timestamp) {
      return formatTimestamp(timestamp, 'yyyy-MM-dd');
    },
  },
  data() {
    return {
      unpaidList: [],
    };
  },
  computed: {
    ...mapState('billModule', ['customerId']),
  },
  async created() {
    await this.getUnPaidList(this.customerId);
  },
  methods: {
    async getActivityList(pageCount, pageSize) {
      return ActivityApi.getActivityList(pageCount, pageSize);
    },

    async getUnPaidList(customerId) {
      const { code, data = {} } = await ActivityApi.getUnPaidList(customerId);
      if (code === STATUS.SUCCESS) {
        if (data.agreementList && data.agreementList.length) {
          this.unpaidList = data.agreementList;
        }
      }
    },

    inUnpaidList(agreementId) {
      return !this.$isWXApplet && this.unpaidList.findIndex((item) => item.agreementId === agreementId) !== -1;
    },

    getActivityDesc,
    getActivityStatusDesc,
    activityIsInProgress,
    onClickDetail(activityId, activityType) {
      this.$router.push({
        name: 'ActivityDetail',
        query: {
          activityId,
          activityType,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.cell-card {
  position: relative;

  .tag {
    position: absolute;
    top: 0.1rem;
    right: 0.1rem;
  }
  .refund-tag {
    position: absolute;
    top: 0.6rem;
    right: 0.1rem;
  }
}
.list-item__has-refund{
  background: rgba(255,100,0,0.12);
}
</style>
